import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    tableId,
    mode = 'all',
    accessToken = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.utable.getTableFields, {
        tableId: Number.parseInt(tableId) || 0,
        mode,
        accessToken,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
